import React, { createContext, useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Login from './Login/Login';
import Register from './Register/Register';
import { auth} from './Auth/FirebaseConfig';
import Home from './Home/Home';
import Profile from './Profile/Profile';
import X from './X';


export const PostsContext = createContext();
  



export default function App() {
       const [posts, setPosts] = useState([]);
        const [user, setUser] = useState([]);
        

      useEffect(() => {
        auth.onAuthStateChanged((authUser) => {
          if (authUser) {
            setUser(authUser);
          } else {
            setUser(false);
          }
        })  
      }, [])
    

  return (
    <div className="">
       <div className="app">
      <PostsContext.Provider value={[posts , setPosts]}>
          <Router>
            <Switch>
            <Route exact path="/x">
                 <X/>
            </Route>
            <Route exact path="/login">
                 <Login/>
            </Route>
            <Route exact path="/register">
                <Register />
             </Route>
            <Route exact path="/">
                 <Home user={user}/>
            </Route>
            <Route exact path="/:userName">
               <Profile user={user} />
            </Route>
            </Switch>
         </Router>
        </PostsContext.Provider>
     </div>
  </div>
  );
};


 